import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
} from "@mui/material";
import { FC } from "react";
import { Option } from "../interface/interface";

interface Props {
  selected: string[];
  options: Option[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
}

export const MultiSelectDropdown: FC<Props> = ({
  selected,
  options,
  onChange,
}) => {
  return (
    <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
      <Select
        multiple
        value={selected}
        onChange={onChange}
        renderValue={(selected) => `${selected.length} Fields selected`}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={selected.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
